module.exports = __webpack_public_path__ + "static/media/Dashboard-active.5eca9604.svg";